import { Outlet } from 'react-router-dom'
import { Box, Container } from '@mui/material'

export function BaseLayout() {
  return (
    <Container>
      <Box
        component="main"
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Outlet />
      </Box>
    </Container>
  )
}
